import React, {memo} from 'react';
import PropTypes from 'prop-types';

import {SearchDateDisplay} from '../SearchDateDisplay/SearchDateDisplay';
import {SearchIcon} from '../SearchIcon/SearchIcon';

import {useComponent} from './hooks/useComponent';

import './SearchDateRangeDisplay.less';

const SearchDateRangeDisplay = memo(function SearchDateRangeDisplay(props) {
    const {
        className,
        startDateClassName,
        separatorClassName,
        endDateClassName,
        locale,
        startLabel,
        endLabel,
        startDate,
        endDate,
        dateFormatOptions,
        isStartActive,
        isEndActive
    } = useComponent(props);

    return (
        <div className={className}>
            <div className={startDateClassName}>
                <SearchDateDisplay
                    locale={locale}
                    label={startLabel}
                    date={startDate}
                    dateFormatOptions={dateFormatOptions}
                    isActive={isStartActive}
                />
            </div>
            <div className={separatorClassName}>
                <SearchIcon name="arrow-right" size="large"/>
            </div>
            <div className={endDateClassName}>
                <SearchDateDisplay
                    locale={locale}
                    label={endLabel}
                    date={endDate}
                    dateFormatOptions={dateFormatOptions}
                    isActive={isEndActive}
                />
            </div>
        </div>
    );
});

SearchDateRangeDisplay.propTypes = {
    locale: PropTypes.string,
    startLabel: PropTypes.string,
    endLabel: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    dateFormatOptions: PropTypes.objectOf(PropTypes.string),
    isSelecting: PropTypes.bool
};

SearchDateRangeDisplay.defaultProps = {};

SearchDateRangeDisplay.whyDidYouRender = true;

export {SearchDateRangeDisplay};
